import { FilterAndSortDetails } from "../../../app/shared/models/filter-sort-details";

export class DocumentSearch {
    documentTypes?: string[];
    localTypes?: string[];
    categories?:string[];
    localCategories?:string[];
    responsibleSubBUs?:string[];
    eQMSScopes?:string[];
    phases?:string[];
    effectiveDates?:string[];
    periodicReviewDates?:string[];
    creationDates?:string[];
    searchText?: string;
    tags?: string;
    filterAndSortDetails?: FilterAndSortDetails;
    users?:string[];
}